import React, { useEffect, useState } from "react";

// JS Files

// Others File
import rulesIcon from "../../imgs/rules.svg";
import inboxIcon from "../../imgs/inbox.svg";

const RulesCard = ({ item }) => {
  return (
    <>
      <div className="border border-myorange-400 rounded-lg  flex flex-col items-center justify-center">
        <img src={rulesIcon} className="w-12 h-12 mt-4" />
        <p className="mt-4 text-mygray-700">{item.title}</p>
        <a className="w-full" href={item.attach_file} target="_blank">
          <div className=" flex items-center justify-center bg-mygray-100 mt-4  rounded-b-lg p-2 cursor-pointer">
            <img src={inboxIcon} />
            <span className="mr-2 text-myorange-500 font-bold">دریافت</span>
          </div>
        </a>
      </div>
    </>
  );
};
export default RulesCard;
